import React, { useState, useRef } from "react";
import "./VerifyPhotographerModal.css";
import Loader from "../../../../Loader/Loader";
import { toast } from "react-toastify";
import {
  SendPhotographerOTPAPI,
  VerifyPhotographerOTPAPI,
} from "../../../../utils/APIs/photographersApis";

const VerifyPhotographerModal = ({ isOpen, onClose, photographer, onVerified }) => {
  // const [phone, setPhone] = useState(photographer?.phone || "");
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  const otpRefs = useRef([]);

  if (!isOpen) return null;

console.log("photographer",photographer?.phone)

  const resetForm = () => {
    // setPhone("");
    setShowOtp(false);
    setOtp(["", "", "", ""]);
    setTimer(30);
    setCanResend(false);
  };

  const startTimer = () => {
    setCanResend(false);
    let count = 30;
    setTimer(count);

    const interval = setInterval(() => {
      count--;
      setTimer(count);
      if (count <= 0) {
        clearInterval(interval);
        setCanResend(true);
      }
    }, 1000);
  };

 

  const handleSendOtp = async () => {
    console.log("PHONE NUMBER",photographer?.phone)
    if (!photographer?.phone || photographer?.phone.length !== 10) {
      toast.error("Enter valid mobile number");
      return;
    }

    try {
      setLoading(true);

      const res = await SendPhotographerOTPAPI({ mobileNumber: photographer?.phone });

      if (res?.data?.success) {
        toast.success(res?.data?.message || "OTP sent successfully");
        setShowOtp(true);
        startTimer();
      } else {
        toast.error(res?.data?.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // move forward
    if (value && index < otp.length - 1) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1].focus();
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");

    if (enteredOtp.length !== 4) {
      toast.error("Enter valid OTP");
      return;
    }

    try {
      setLoading(true);

      const res = await VerifyPhotographerOTPAPI({
        mobileNumber: photographer?.phone,
        OTP: enteredOtp,
        // photographerId: photographer?._id,
      });

      if (res?.data?.success) {
        toast.success(res?.data?.message || "Photographer verified successfully!");
        resetForm();
        onClose();
        onVerified && onVerified();
      } else {
        toast.error(res?.data?.message || "OTP verification failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  

  if (loading) return <Loader />;

  return (
    <div className="main-modal">
      <div className="modal-card text-center">
        <h3>Verify Photographer</h3>

        {!showOtp && (
          <div className="form-group phone-verify-group text-start">
            <div className="form-group text-start">
              <label className="form-label">Photographer Type</label>
              <input
                type="text"
                className="form-control"
                value={photographer?.photographerType || ""}
                readOnly
              />
            </div>

            <label className="form-label">Mobile Number</label>
            <input
              type="text"
              className="form-control"
              value={photographer?.phone || ""}
              readOnly
            />

            <button className="btn-confirm" onClick={handleSendOtp}>
              Send OTP
            </button>
          </div>
        )}

        {showOtp && (
          <>
           <div className="form-group text-center">
  <label className="form-label d-block mb-2">Enter OTP</label>

  <div className="otp-group">
    {otp.map((digit, index) => (
      <input
        key={index}
        ref={(el) => (otpRefs.current[index] = el)}
        type="text"
        inputMode="numeric"
        maxLength="1"
        className="otp-input"
        value={digit}
        onChange={(e) => handleOtpChange(e.target.value, index)}
        onKeyDown={(e) => handleOtpKeyDown(e, index)}
      />
    ))}
  </div>
</div>

            <div className="d-flex justify-content-between mt-2">
              {canResend ? (
                <span className="text-primary-otp" onClick={handleSendOtp} style={{ cursor: "pointer" }}>
                  Resend OTP
                </span>
              ) : (
                <span>Resend in {timer}s</span>
              )}
            </div>
 <button className="btn-confirm  mt-2" onClick={handleVerifyOtp}>
              Verify OTP
            </button>
           
          </>
        )}


        
            <button
          className="btn-cancel mx-3"
          onClick={() => {
            resetForm();
            onClose();
          }}
        >
          Cancel
        </button>

        
      </div>
    </div>
  );
};

export default VerifyPhotographerModal;
